import { render, staticRenderFns } from "./LegalDocumentEscalations.vue?vue&type=template&id=28396dff&scoped=true&"
import script from "./LegalDocumentEscalations.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentEscalations.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentEscalations.vue?vue&type=style&index=0&id=28396dff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28396dff",
  null
  
)

export default component.exports